import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { TransactionListStateCell } from '@app/feature/transaction/transaction-list/transaction-list-state.cell';
import { TransactionListStateHeader } from '@app/feature/transaction/transaction-list/transaction-list-state.header';

export const TokenTransactionListStateColumn: IdentifiedColumnDef<
  TransactionModel,
  TransactionModel['state']
> = {
  enableSorting: false,
  header: TransactionListStateHeader,
  cell: TransactionListStateCell,
};
